<template>
  <div class="rate-view">
    <span v-if="!content || content === '-'">{{content || '-'}}</span>
    <Tooltip :transfer="true" v-else>
      <span :style="eventStyle" @click="clickHandle" v-html="content" v-if="$options.filters.removeTag(content).length < charLen"></span>
      <span :style="eventStyle" @click="clickHandle" class="shenglue" v-else>{{content}}</span>
      <div slot="content" style="text-align:center;font-size:13px;white-space:normal;line-height: 20px;" v-html="content" v-if="$options.filters.removeTag(content).length < charLen"></div>
      <div slot="content" style="text-align:left;font-size:13px;white-space:normal;line-height: 20px;" v-html="content" v-else></div>
    </Tooltip>
  </div>
</template>

<script>
export default {
  name: 'RateView',
  props: ['content', 'strLen', 'hasEvent'],
  computed: {
    charLen () {
      let winWidth = this._h.getWinWidth()
      if (winWidth > 1300) {
        if (this.strLen && this.strLen > 0) {
          return this._.min([this.strLen, 10])
        } else {
          return 11
        }
      } else {
        if (this.strLen && this.strLen > 0) {
          return this._.min([this.strLen, 6])
        } else {
          return 6
        }
      }
    },
    eventStyle () {
      return this.hasEvent ? {
        cursor: 'pointer',
        color: '#0470e3'
      } : {
        cursor: 'default',
      
   
      }
    }
  },
  methods: {
    clickHandle (e) {
       if (this.content != "-") this.$emit("clickContent", true);
    }
  }
}
</script>
<style scoped>
 .shenglue{
  display: inline-block;
  text-Overflow: ellipsis;
  overflow: hidden;
  white-Space: nowrap;
  width: 114px;
  height: 18px;
 }
</style>




// WEBPACK FOOTER //
// src/components/query/common/RateView.vue